import { getCurrentEnvironment } from './env.config';

interface WaffleTile {
  link: string;
  image: string;
  text: string;
  imageClass?: string;
}

// Base URLs for different environments
export const getBaseUrl = (): string => {
  const env = getCurrentEnvironment();
  
  switch (env) {
    case 'prod':
      return 'https://3eonline.com';
    case 'beta':
      return 'https://beta.3eonline.com';
    case 'dev':
      return 'https://dev.3eonline.com';
    case 'local':
    default:
      return 'https://dev.3eonline.com'; // Default to production for local development
  }
};

// Generate waffle items with environment-specific links
export const getWaffleItems = (): WaffleTile[] => {
  const baseUrl = getBaseUrl();
  
  return [
    {
      link: `${baseUrl}/eeeonlineportal`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-protect/icon-logo-color-rgb.svg",
      text: "3E Protect"
    },
    {
      link: `${baseUrl}/msdgen`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-generate/icon-logo-color-rgb.svg",
      text: "3E Generate"
    },
    {
      link: `${baseUrl}/webinsight`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-insight-for-chemicals/icon-logo-color-rgb.svg",
      text: "3E Insight for Chemicals"
    },
    {
      link: `${baseUrl}/3esc/Alert`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-monitor/icon-logo-color-rgb.svg",
      text: "3E Monitor"
    },
    {
      link: `${baseUrl}/notify`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-notify/icon-logo-color-rgb.svg",
      text: "3E Notify"
    },
    {
      link: `${baseUrl}/ariellogic`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-insight-for-food/icon-logo-color-rgb.svg",
      text: "3E Insight for Food"
    },
    {
      link: `${baseUrl}/3esc`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-connect/icon-color-rgb.svg",
      text: "3E Connect"
    },
    {
      link: `${baseUrl}/eeeonlineportal/DesktopDefault.aspx?tabid=138`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-erc/icon-logo-color-rgb.svg",
      text: "3E ERC"
    },
    {
      link: `${baseUrl}/3eoptimize`,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-optimize/icon-logo-color-rgb.svg",
      text: "3E Optimize"
    },
    {
      link: baseUrl,
      image: "https://cdn.3enucleus.com/images/logo-v2022/3e-iq/img-logo-blue-rgb.svg",
      text: "Return to 3EiQ",
      imageClass: "iqlogo"
    }
  ];
};

export default getWaffleItems;